import { render, staticRenderFns } from "./edite.vue?vue&type=template&id=fe2e088a&scoped=true&"
import script from "./edite.vue?vue&type=script&lang=ts&"
export * from "./edite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2e088a",
  null
  
)

export default component.exports